import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import RescheduleLink from '../containers/RescheduleLink';
import AddToCalendarButton from '../../components/AddToCalendarButton';

const Controls = ({
  canceled,
  inFuture,
  isCancelable,
  cancelAppointment,
  barberName,
  serviceName,
  shop,
  customer,
  appointment,
  rebookLink,
  scheduleLink,
  clearReservations,
}) => {
  if (!canceled && inFuture) {
    return (
      <div>
        {isCancelable && <RescheduleLink />}
        {isCancelable && <button onClick={cancelAppointment} className="c-btn c-btn--secondary u-1/1 u-mb--">
           Cancel appointment
         </button>
        }
        <AddToCalendarButton
          barberName={barberName}
          serviceName={serviceName}
          shop={shop}
          customer={customer}
          appointment={appointment}
        />
        <Link
          onClick={clearReservations}
          to={scheduleLink}
          className="c-btn c-btn--secondary u-1/1 u-mt--"
        >
          Schedule another appointment
        </Link>
      </div>
    );
  }

  return (
    <Link to={rebookLink} className="c-btn c-btn--secondary u-1/1">
      Rebook appointment
    </Link>
  );
};
Controls.propTypes = {
  appointment: PropTypes.shape({
    start: PropTypes.string,
    formatted: PropTypes.string,
    duration: PropTypes.number,
  }).isRequired,
  barberName: PropTypes.string,
  serviceName: PropTypes.string,
  shop: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string,
    zip: PropTypes.string,
    location: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  }).isRequired,
  customer: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  inFuture: PropTypes.bool,
  canceled: PropTypes.bool,
  rebookLink: PropTypes.string,
  isCancelable: PropTypes.bool.isRequired,
  cancelAppointment: PropTypes.func.isRequired,
  scheduleLink: PropTypes.string,
  clearReservations: PropTypes.func.isRequired,
};
Controls.defaultProps = {
  barberName: '',
  serviceName: '',
  inFuture: false,
  canceled: true,
  rebookLink: '/',
  scheduleLink: '/',
};

export default Controls;



// WEBPACK FOOTER //
// ./src/app/reservation/components/Controls.jsx